import { render, staticRenderFns } from "./ScoreCompare.vue?vue&type=template&id=19fdf61a&scoped=true"
import script from "./ScoreCompare.vue?vue&type=script&lang=js"
export * from "./ScoreCompare.vue?vue&type=script&lang=js"
import style0 from "./ScoreCompare.vue?vue&type=style&index=0&id=19fdf61a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fdf61a",
  null
  
)

export default component.exports